class Cooperado {
  constructor() {
    
  }
}

export default Cooperado
